import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { getAllParams } from '@frontend/sports/common/core/utils/route-params';
import { AdaptiveLayoutState } from '@frontend/sports/layout/feature';
import { toInteger } from 'lodash-es';

import { SubNavigationResolve } from '../sub-navigation-resolve.service';
import { SportSubNavigationService } from './sport-sub-navigation.service';

@Injectable({ providedIn: 'root' })
export class SportSubNavigationResolve extends SubNavigationResolve<void> {
    private sportSubNavService = inject(SportSubNavigationService);

    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot): void {
        const sport = toInteger(getAllParams(routeSnapshot).sport);
        this.sportSubNavService.resolveTabs(layout, routeSnapshot, sport).subscribe((items) => this.tabs$.next(items));
    }
}
